<template>
  <section class="home-intelligent-video" aria-labelledby="home-intelligent-video-title">
    <div class="home-intelligent-video__inner">
      <div class="home-intelligent-video__copy">
        <h2 id="home-intelligent-video-title">Intelligent Video</h2>
        <p class="home-intelligent-video__subtitle">scrubbing saves valuable time</p>
        <p class="home-intelligent-video__body">
          Periscope AI’s integrated AI combs through hours of video footage to quickly
          surface important events.
        </p>
      </div>

      <div class="home-intelligent-video__media-frame">
        <MotionMedia
          class="home-intelligent-video__media"
          :src="vitbVideo"
          :poster="vitbPoster"
        />
      </div>
    </div>
  </section>
</template>

<script>
import MotionMedia from '@/components/journey/MotionMedia.vue'
import vitbVideo from '@/assets/videos/vitb-machine-vision-demo.mp4'
import vitbPoster from '@/assets/images/video-posters/vitb-machine-vision-poster.jpg'

export default {
  name: 'IntelligentVideoStory',
  components: { MotionMedia },
  data() {
    return {
      vitbVideo,
      vitbPoster,
    }
  },
}
</script>

<style lang="scss">
#app .home-intelligent-video {
  padding: clamp(96px, 8vw, 126px) 0 clamp(100px, 8.5vw, 134px);
  color: var(--ink);
  background: var(--sand);
}

#app .home-intelligent-video__inner {
  display: grid;
  width: min(calc(100% - 80px), var(--page));
  margin: 0 auto;
  grid-template-columns: minmax(310px, 0.7fr) minmax(0, 1.3fr);
  gap: clamp(62px, 8vw, 124px);
  align-items: center;
}

#app .home-intelligent-video h2 {
  max-width: 8ch;
  margin: 0 0 17px;
  color: var(--ink);
  font-size: clamp(4rem, 6vw, 6.3rem);
  letter-spacing: -0.05em;
  line-height: 0.92;
}

#app .home-intelligent-video__subtitle {
  max-width: 18ch;
  margin: 0 0 31px;
  color: var(--brand-blue);
  font-size: clamp(1.45rem, 2vw, 2rem);
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1.12;
}

#app .home-intelligent-video__body {
  max-width: 470px;
  margin: 0;
  color: var(--copy-dark);
  font-size: clamp(1.08rem, 1.25vw, 1.18rem);
  line-height: 1.65;
}

#app .home-intelligent-video__media-frame {
  min-width: 0;
  overflow: hidden;
  background: var(--near-black);
}

#app .home-intelligent-video__media {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  filter: saturate(0.82) contrast(1.04) brightness(0.92);
}

@media (max-width: 1024px) {
  #app .home-intelligent-video__inner {
    width: calc(100% - 60px);
    grid-template-columns: minmax(280px, 0.8fr) minmax(0, 1.2fr);
    gap: 44px;
  }
}

@media (max-width: 820px) {
  #app .home-intelligent-video {
    padding: 88px 0 98px;
  }

  #app .home-intelligent-video__inner {
    width: calc(100% - 40px);
    grid-template-columns: 1fr;
    gap: 48px;
  }

  #app .home-intelligent-video__copy {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(220px, 0.72fr);
    column-gap: 38px;
    align-items: end;
  }

  #app .home-intelligent-video h2 {
    margin-bottom: 0;
    font-size: clamp(3.8rem, 10vw, 5.3rem);
    grid-row: 1 / span 2;
  }

  #app .home-intelligent-video__subtitle {
    margin-bottom: 18px;
  }
}

@media (max-width: 620px) {
  #app .home-intelligent-video {
    padding: 80px 0 88px;
  }

  #app .home-intelligent-video__inner {
    gap: 38px;
  }

  #app .home-intelligent-video__copy {
    display: block;
  }

  #app .home-intelligent-video h2 {
    margin-bottom: 14px;
    font-size: clamp(3.3rem, 14vw, 4.25rem);
  }

  #app .home-intelligent-video__subtitle {
    margin-bottom: 25px;
    font-size: 1.4rem;
  }

  #app .home-intelligent-video__body {
    font-size: 1.04rem;
  }
}
</style>
